import type { IMenuItem } from '@/shared/ui/menu.types';

export const TRAVELERS_MENU_ITEMS: IMenuItem[] = [
  { label: 'О компании', slug: 'about-company', link: '/about/company/' },
  { label: 'Частые вопросы', slug: '' },
  { label: 'Пользовательское соглашение', slug: 'terms', link: '/about/terms/' },
  { label: 'Политика возврата', slug: 'cancellation-policy', link: '/about/cancellation_policy/' },
  { label: 'Безопасность платежей', slug: 'secure-payments', link: '/about/secure_payments/' },
  { label: 'Политика конфиденциальности', slug: 'privacy-policy', link: '/about/privacy_policy/' },
  {
    label: 'Обработка персональных данных',
    slug: 'personal-data',
    link: '/about/soglasie-na-obrabotku-personalnyh-dannyh/',
  },
  {
    label: 'Реклама и информационные сообщения',
    slug: 'promo-and-info',
    link: '/about/soglasie-na-reklamnuyu-i-informaczionnuyu-rassylku/',
  },
  { label: 'Партнёрская программа', slug: 'partners', link: '/partners/' },
  { label: 'Оферта для партнёров', slug: 'terms-partners', link: '/about/terms_partners/' },
  { label: 'Оферта для организаторов', slug: 'terms-organizers', link: '/about/terms_organizers/' },
];
